import {createContext, useContext} from 'react';

export type CommentsContextValue = {
	/** вошёл и не заблокирован: может писать и отвечать */
	canWrite: boolean;
	isAdmin: boolean;
	/** текущее время для относительных дат; пока не определено, показывается точная дата */
	now?: number;
	userId?: string;
	/** кто из авторов страницы заблокирован; заполняется только у администратора */
	blockedAuthors: ReadonlySet<string>;
	reply: (parentId: string, text: string) => Promise<unknown>;
	edit: (id: string, text: string) => Promise<unknown>;
	remove: (id: string) => Promise<unknown>;
	setBlocked: (userId: string, blocked: boolean) => Promise<unknown>;
};

export const CommentsContext = createContext<CommentsContextValue>(null as unknown as CommentsContextValue);

export const useCommentsContext = () => useContext(CommentsContext);
